import InvoicesContainer from './invoices-container';

export default InvoicesContainer;
